export const CHAT_STREAM_PATH = 'chat/v1/invoke_agent/stream';
export const CHAT_PATH = 'chat/v1/invoke_agent';
export const BASE_STREAM_URL = '/gateway/api/assist';
